import { faker } from '@faker-js/faker'

import { UserReservationDetail } from '../../contracts/reservation'
import { asBuilder } from '../asBuilder'

export const getReservations = asBuilder<UserReservationDetail[]>((): UserReservationDetail[] => {
  return faker.helpers.multiple(
    () => ({
      id: faker.number.int(),
      changedCount: faker.number.int(),
      thresholdChangedCount: faker.number.int(),
      cancelReasonCode: faker.string.uuid(),
    }),
    { count: faker.number.int({ min: 1, max: 10 }) },
  )
})
